import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import WebhooksIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/WebhooksIcon';

import WebhooksButton from '../OtherComponents/WebhooksButton';

const WebhooksStrategy = {
  previewInfo: {
    name: 'Webhooks',
    iconSvg: <WebhooksIcon size="xlarge" />,
    newTab: true,
  },
  headerInfo: {
    name: 'Webhooks',
    category: 'Get data out of Housecall Pro and into any app',
    details: (
      <div>
        Webhooks allow you to send real time notifications for actions happening in Housecall Pro to your own web app or
        the API of another product or service you use to run your business. Keep your systems in sync and avoid double
        entry with automation powered by our webhooks.
      </div>
    ),
    iconSvg: <WebhooksIcon size="superJumbo" />,
  },
  sellingPoints: {
    headline: 'Webhooks currently include events for actions on',
    description: '',
    unorderedPoints: ['Jobs', 'Estimates', 'Customers'],
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Not Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Not Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    appActionButton: <WebhooksButton />,
    hideToggle: true,
    showBetaButton: false,
    hideCard: true,
  },
  supportContacts: [],
};

export default WebhooksStrategy;
